import Vue from 'vue';
import Vuex from 'vuex';

import app from './modules/app';
import user from './modules/user';

Vue.use(Vuex);

const store = new Vuex.Store({
  mutations: {
    handleOrderPaid: (state, notice) => { state.orderPaidNotice = notice }
  },
  modules: {
    app,
    user
  }
});

export default store;



// WEBPACK FOOTER //
// ./src/store/index.js